export const chat = {
  online: "Online",
  offline: "Offline",
  startConversation: "Iniciar conversa",
  moreOptions: "Mais opções",
  noMessages: "Nenhuma mensagem ainda. Inicie a conversa!",
  typeMessage: "Digite uma mensagem...",
  sendFailed: "Falha ao enviar mensagem: %{error}",
  messageDeleted: "Esta mensagem foi apagada",
  privateNote: "Nota privada - visível apenas para atendentes",
  privateLabel: "Privada",
  edited: "Editada",
  attachment: "Anexo",
  file: "Arquivo",
  fileNotAvailable: "Arquivo não disponível",
  image: "Imagem",
  audioNotSupported: "Seu navegador não suporta o elemento de áudio",
  videoNotSupported: "Seu navegador não suporta o elemento de vídeo",
  media: "Mídia",
  fileCannotBePreview: "Este tipo de arquivo não pode ser visualizado.",
  downloadFile: "Baixar Arquivo",
  unknownSender: "Desconhecido",
  unknownContact: "Contato desconhecido",
  selectConversation: "Selecione uma conversa",
  selectConversationHint: "Escolha uma conversa na lista à esquerda para começar",
  noConversationSelected: "Nenhuma conversa selecionada",
  noTicketMessage: "Selecione um ticket para visualizar a conversa",
  noTicketSelected: "Nenhum ticket selecionado",
  selectTicketToView: "Selecione um ticket para visualizar a conversa",
  startConversationHint: "Inicie a conversa!",
  loadMore: "Carregar mais mensagens",
  toggleDetails: "Mostrar/ocultar detalhes",
  details: "Detalhes",
  attachFile: "Anexar arquivo",
  addEmoji: "Adicionar emoji",
  quickReplies: "Respostas rápidas",
  quickReplySearch: "Buscar resposta rápida...",
  noQuickReplies: "Nenhuma resposta rápida encontrada",
  pasteImage: "Imagem colada",
  fileTooLarge: "%{provider} limita envios a %{maxSize}. Arquivo ignorado: %{files}",
  sendError: "Erro ao enviar mensagem. Tente novamente.",
  forwarded: "Encaminhada",
  ephemeral: "Mensagem temporária",
  forward: {
    title: "Encaminhar mensagem",
    forwarding: "Encaminhando:",
    searchContact: "Buscar contato...",
    send: "Encaminhar",
    success: "Mensagem encaminhada",
    noConversation: "Nenhuma conversa encontrada para este contato",
    noResults: "Nenhum contato encontrado",
    typeToSearch: "Digite para buscar contatos",
    group: "Grupo",
  },
  provider: "O provedor",
  messageInput: "Campo de mensagem",
  muteConversation: "Silenciar conversa",
  unmuteConversation: "Reativar notificações",
  blockContact: "Bloquear contato",
  editChannel: "Editar Canal",
  addMembers: "Adicionar Membros",
  leaveConversation: "Sair da Conversa",
  deleteConversation: "Excluir Conversa",
  conversationUpdated: "Conversa atualizada com sucesso",
  conversationDeleted: "Conversa excluída com sucesso",
  participantsAdded: "Participantes adicionados com sucesso",
  participantRemoved: "Participante removido com sucesso",
  leftConversation: "Você saiu da conversa",
  updateError: "Erro ao atualizar conversa",
  deleteError: "Erro ao excluir conversa",
  addParticipantsError: "Erro ao adicionar participantes",
  removeParticipantError: "Erro ao remover participante",
  leaveError: "Erro ao sair da conversa",
  cannotLeaveOnlyParticipant: "Você é o único participante desta conversa. Considere excluí-la.",
  messageEdited: "Mensagem editada com sucesso",
  messageDeletedSuccess: "Mensagem excluída com sucesso",
  editMessageError: "Erro ao editar mensagem",
  editMessageForbidden: "Você não pode editar esta mensagem",
  editMessageExpired: "O tempo para editar esta mensagem expirou",
  deleteMessageError: "Erro ao excluir mensagem",
  deleteMessageForbidden: "Você não pode excluir esta mensagem",
  deleteMessageExpired: "O tempo para excluir esta mensagem expirou",
  confirmLeave: "Sair da Conversa",
  confirmLeaveMessage: "Tem certeza que deseja sair desta conversa? Você não receberá mais mensagens deste grupo.",
  confirmDelete: "Excluir Conversa",
  confirmDeleteMessage: "Tem certeza que deseja excluir esta conversa? Esta ação não pode ser desfeita e a conversa será removida para todos os participantes.",
  typing: {
    one: "%{name} está digitando",
    two: "%{name1} e %{name2} estão digitando",
    many: "%{count} pessoas estão digitando",
    someone: "Alguém",
  },
  time: {
    justNow: "Agora mesmo",
    minutesAgo: "%{count} min atrás",
    hoursAgo: "%{count}h atrás",
    today: "Hoje",
    yesterday: "Ontem",
    daysAgo: "%{count} dias atrás",
  },
  attachments: {
    image: "Imagem",
    video: "Vídeo",
    audio: "Áudio",
    document: "Documento",
    unknownType: "Tipo desconhecido",
    dragDrop: "Arraste arquivos aqui ou clique para selecionar",
    limits: "Máximo %{maxFiles} arquivos, até %{maxSize}MB cada",
    maxFilesExceeded: "Máximo de %{max} arquivos permitidos",
    fileTooLarge: "Arquivo %{name} é muito grande. Máximo: %{maxSize}MB",
    duplicate: "Arquivo %{name} já foi adicionado",
    addMore: "Adicionar mais arquivos",
    maxReached: "Máximo de %{max} arquivos atingido",
  },
  connection: {
    connected: "Conectado",
    disconnected: "Desconectado",
    reconnecting: "Reconectando...",
    reconnectFailed: "Falha na reconexão",
    reconnectFailedMessage: "Não foi possível reconectar ao servidor. Por favor, atualize a página.",
    prolongedDisconnection: "A conexão está demorando para restabelecer.",
    checkConnectionSuggestion: "Verifique sua conexão com a internet e considere atualizar a página.",
    attempt: "Tentativa",
    refresh: "Atualizar página",
    dismiss: "Dispensar",
  },
  tags: {
    noTags: "Sem tags",
    selectTag: "Selecionar tag",
    noAvailableTags: "Nenhuma tag disponível",
    added: "Tag adicionada com sucesso",
    removed: "Tag removida com sucesso",
    addError: "Erro ao adicionar tag",
    removeError: "Erro ao remover tag",
  },
  poll: {
    title: "Enquete",
    multipleChoice: "múltipla escolha",
    closed: "Encerrada",
    yourVote: "Seu voto",
    totalVotes: "%{count} voto |||| %{count} votos",
  },
  preview: {
    image: "Foto",
    video: "Vídeo",
    audio: "Mensagem de voz",
    document: "Documento",
    sticker: "Figurinha",
    location: "Localização",
    liveLocation: "Localização em tempo real",
    contact: "Contato",
    contactCard: "Cartão de contato",
    poll: "Enquete",
    call: "Chamada",
    system: "Mensagem do sistema",
  },
  systemEvents: {
    new_chat_members: "entrou no grupo",
    left_chat_member: "saiu do grupo",
    new_chat_title: "O grupo foi renomeado",
    new_chat_photo: "A foto do grupo foi alterada",
    delete_chat_photo: "A foto do grupo foi removida",
    group_chat_created: "Grupo criado",
    supergroup_chat_created: "Supergrupo criado",
    channel_chat_created: "Canal criado",
    pinned_message: "Mensagem fixada",
    migrate_to_supergroup: "O grupo foi convertido em supergrupo",
    forum_topic_created: "Tópico criado",
    forum_topic_closed: "Tópico encerrado",
    forum_topic_reopened: "Tópico reaberto",
    forum_topic_edited: "Tópico editado",
    video_chat_started: "Chamada de vídeo iniciada",
    video_chat_ended: "Chamada de vídeo encerrada",
    video_chat_participants_invited: "Participantes convidados para chamada de vídeo",
    unsupported_message_type: "Tipo de mensagem não suportado",
  },
};
